import request from '@/utils/request';

/**
 * 获取当前用户有权限的菜单树
 */
export function getMyMenus() {
  return request({
    url: '/rbac/menus/my_menus',
    method: 'get',
  });
}

/**
 * 获取所有菜单树（仅管理员）
 */
export function getAllMenus() {
  return request({
    url: '/rbac/menus/all',
    method: 'get',
  });
}

/**
 * 获取单个菜单详情
 */
export function getMenuDetail(menuId) {
  return request({
    url: `/rbac/menus/${menuId}`,
    method: 'get',
  });
}

/**
 * 创建菜单
 */
export function createMenu(data) {
  return request({
    url: '/rbac/menus/',
    method: 'post',
    data,
  });
}

/**
 * 更新菜单
 */
export function updateMenu(menuId, data) {
  return request({
    url: `/rbac/menus/${menuId}`,
    method: 'put',
    data,
  });
}

/**
 * 删除菜单
 */
export function deleteMenu(menuId) {
  return request({
    url: `/rbac/menus/${menuId}`,
    method: 'delete',
  });
}

/**
 * 为角色分配菜单
 */
export function assignMenusToRole(roleId, data) {
  return request({
    url: `/rbac/menus/roles/${roleId}/menus`,
    method: 'post',
    data,
  });
}

/**
 * 获取角色的菜单
 */
export function getRoleMenus(roleId) {
  return request({
    url: `/rbac/menus/roles/${roleId}/menus`,
    method: 'get',
  });
}
